const doc = [({"zh_tw":({"adminConstantHotelLinkType":({"allLink":"顯示全部", "engineLink":"僅在 Tabichat Engine", "noneLink":"隱"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;